export default "__VITE_PUBLIC_ASSET__213ffc62__"